<template>
  <div>
    <h2 class="text-xl font-semibold mb-4">Results</h2>
    <div class="space-y-4">
      <div
        v-for="n in 5"
        :key="n"
        class="p-4 border rounded-xl shadow-sm bg-white"
      >
        <h3 class="font-medium text-brand-darkblue">Sample Space {{ n }}</h3>
        <p class="text-sm text-secondary">Example description goes here.</p>
      </div>
    </div>
  </div>
</template>

<script setup></script>
